var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Voice-Mail-Off--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "voice-mail-off--mic-audio-mike-music-microphone-mute-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#7085cb",
    d: "M9.5 6.5c0 0.66304 -0.26339 1.29893 -0.73223 1.76777C8.29893 8.73661 7.66304 9 7 9c-0.66304 0 -1.29893 -0.26339 -1.76777 -0.73223C4.76339 7.79893 4.5 7.16304 4.5 6.5V3c0 -0.66304 0.26339 -1.29893 0.73223 -1.76777C5.70107 0.763392 6.33696 0.5 7 0.5c0.66304 0 1.29893 0.263392 1.76777 0.73223C9.23661 1.70107 9.5 2.33696 9.5 3v3.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 13.5 0.5 0.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.49999 8.5c0.31107 -0.23233 0.5635 -0.53417 0.73713 -0.88144 0.17363 -0.34726 0.26365 -0.73031 0.26287 -1.11856V3c0 -0.66304 -0.26339 -1.29893 -0.73223 -1.76777C8.29892 0.763392 7.66304 0.5 6.99999 0.5c-0.66304 0 -1.29892 0.263392 -1.76776 0.73223C4.76339 1.70107 4.49999 2.33696 4.49999 3v1.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.73 7.54004c0.25542 0.55852 0.7075 1.00347 1.27 1.25",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.42 10.42c0.4969 -0.42025 0.8959 -0.94417 1.1688 -1.53499 0.273 -0.59081 0.4133 -1.2342 0.4112 -1.88501",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 7c-0.00132 0.59132 0.11418 1.17707 0.33985 1.72363 0.22568 0.54656 0.5571 1.04316 0.97523 1.46127 0.41812 0.4181 0.91472 0.7496 1.46128 0.9752 0.54656 0.2257 1.13232 0.3412 1.72364 0.3399h1c0.18653 0.01 0.37346 0.01 0.56 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    stroke: "#fefeff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 11.5v2",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMic);
export default __webpack_public_path__ + "static/media/no_mic.a10ff16f7ad73397fc455f41257e3027.svg";
export { ForwardRef as ReactComponent };